import { STANDARD_UNIFIED_ROLES, type StandardUnifiedRole } from '@/constants/mailbox';
import type { Folder } from '@/types/email';

function normalizeText(value: string | null | undefined): string {
  return (value || '').trim().toLowerCase();
}

export function inferUnifiedRole(folder: Folder): StandardUnifiedRole | null {
  if (folder.unifiedRole && (STANDARD_UNIFIED_ROLES as readonly string[]).includes(folder.unifiedRole)) {
    return folder.unifiedRole as StandardUnifiedRole;
  }

  const directRole = normalizeText(folder.role || null);
  if (directRole && (STANDARD_UNIFIED_ROLES as readonly string[]).includes(directRole)) {
    return directRole as StandardUnifiedRole;
  }

  const name = normalizeText(folder.name);
  const path = normalizeText(folder.path);

  const inboxNames = ['inbox', 'boîte de réception'];
  if (inboxNames.includes(name) || inboxNames.includes(path)) {
    return 'inbox';
  }

  const sentNames = ['sent', 'sent items', 'sent mail', 'inviati', 'enviados'];
  if (sentNames.includes(name) || sentNames.includes(path)) {
    return 'sent';
  }

  const draftsNames = ['drafts', 'draft', 'brouillons'];
  if (draftsNames.includes(name) || draftsNames.includes(path)) {
    return 'drafts';
  }

  const spamNames = ['spam', 'junk', 'junk email', 'courrier indésirable'];
  if (spamNames.includes(name) || spamNames.includes(path)) {
    return 'spam';
  }

  const trashNames = ['trash', 'bin', 'deleted items', 'deleted messages', 'poubelle'];
  if (trashNames.includes(name) || trashNames.includes(path)) {
    return 'trash';
  }

  const archiveNames = ['archive', 'all mail', 'archivio'];
  if (archiveNames.includes(name) || archiveNames.includes(path)) {
    return 'archive';
  }

  return null;
}
